import {
    Box, Button, Checkbox, Input, Radio, RadioGroup, Stack, Text, Center,
    Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon,
} from "@chakra-ui/react"
import Select from 'react-select'
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"


export default function RoutingOptionsSubform({ setRoutingOptions }) {

    const { journeys } = useSelector((state) => state.journeys)
    const { maps } = useSelector((state) => state.creator)

    const [alternativeRoute, setAlternativeRoute] = useState('1st')
    const [pastYearRouting, setPastYearRouting] = useState('current')

    useEffect(() => {
        setRoutingOptions({
            alternativeRoute: alternativeRoute,
            pastYearRouting: pastYearRouting,
        })
    }, [alternativeRoute, pastYearRouting])

    // Clearing table by detecting change in journeys or maps (creator)
    useEffect(() => {
        setAlternativeRoute('1st')
        setPastYearRouting('current')
    }, [journeys, maps])

    return (
        <>
            <Accordion
                allowMultiple
            >
                <AccordionItem>
                    <h2>
                        <AccordionButton>
                            <Box flex="1" textAlign="left">
                                Advanced routing
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4}>
                        <Stack>
                            <Box>
                                <Text>Alternative route:</Text>
                                <RadioGroup onChange={setAlternativeRoute} value={alternativeRoute} defaultValue="1st">
                                    <Stack direction="row">
                                        <Radio value="1st" id="1st" name="alternativeRoute">
                                            Default
                                        </Radio>
                                        <Radio value="2nd" id="2nd" name="alternativeRoute">
                                            2nd
                                        </Radio>
                                        <Radio value="3rd" id="3rd" name="alternativeRoute">
                                            3rd
                                        </Radio>
                                        <Radio value="4th" id="4th" name="alternativeRoute">
                                            4th
                                        </Radio>
                                    </Stack>
                                </RadioGroup>
                                {process.env.REACT_APP_ENABLEPASTYEARROUTING === 'true' && (
                                <Box>
                                    <Text>Custom year: </Text>
                                    <RadioGroup onChange={setPastYearRouting} value={pastYearRouting} defaultValue="current">
                                        <Stack direction="row">
                                            <Radio value="current" id="current" name="pastYearRouting">
                                                Up-to-date
                                            </Radio>
                                            <Radio value="2017" id="2017" name="pastYearRouting">
                                                2017
                                            </Radio>
                                        </Stack>
                                    </RadioGroup>
                                </Box>
                                )}
                                
                            </Box>
                        </Stack>
                    </AccordionPanel>
                </AccordionItem>
            </Accordion>
        </>
    )
}